import React, { useState, useEffect } from 'react';
import DocumentaryCard from './DocumentaryCard';
import styles from './css/DocumentFullPage.module.css';
import { useVideosByCategory } from '../../hooks/useVideosHooks';
import { useParams } from 'react-router-dom';
import Loading from '../../common/HousGlass Loader/Loading';
import Footer from '../../common/UI/Footer';

const DocumentarySection = () => {
  const { category } = useParams();
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 30;
  const [heroIndex, setHeroIndex] = useState(0);

  // Get videos for the category
  const {
    videos,
    isLoading,
    error,
    totalPages
  } = useVideosByCategory(category, currentPage, itemsPerPage);

  // Get featured videos for hero section (latest 3)
  const heroVideos = videos?.slice(0, 3) || [];

  // Auto-rotate hero section
  useEffect(() => {
    if (heroVideos.length > 0) {
      const interval = setInterval(() => {
        setHeroIndex((prevIndex) => (prevIndex + 1) % heroVideos.length);
      }, 5000);
      
      return () => clearInterval(interval);
    }
  }, [heroVideos]);

  // Handle pagination
  const handlePageChange = (newPage) => {
    if (newPage > 0 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  if (isLoading) {
    return <div className={styles.loading}><Loading /></div>;
  }

  if (error) {
    return <div className={styles.error}>Error loading documentaries.</div>;
  }

  if (!videos || videos.length === 0) {
    return null;
  }


  return (
    <>
    <div className={styles.documentarySection}>
      {/* Hero Section */}
      {heroVideos.length > 0 && (
        <div className={styles.heroSection}>
          <div 
            className={styles.heroContent} 
            style={{ backgroundImage: `url(${heroVideos[heroIndex].computer_image_url})` }}
          >
            <div className={styles.heroOverlay}>
              <div className={styles.heroInfo}>
                <h1 className={styles.heroTitle}>{heroVideos[heroIndex].title}</h1>
                <p className={styles.heroDescription}>{heroVideos[heroIndex].description}</p>
                <div className={styles.heroActions}>
                  <button className={styles.watchNowButton}>
                    <span className={styles.playIcon}>▶</span> Watch Now
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className={styles.heroDots}>
            {heroVideos.map((_, index) => (
              <span 
                key={index} 
                className={`${styles.heroDot} ${index === heroIndex ? styles.activeDot : ''}`}
                onClick={() => setHeroIndex(index)}
              />
            ))}
          </div>
        </div>
      )}

      {/* Main Content */}
      <div className={styles.documentariesContainer}>
        <div className={styles.sectionHeader}>
          <h2 className={styles.pageTitle}>
            {category ? category.charAt(0).toUpperCase() + category.slice(1) : 'Documentaries'}
          </h2>
        </div>

        <div className={styles.cardContainer}>
          {videos.map((doc) => (
            <DocumentaryCard key={doc.id} documentary={doc} />
          ))}
        </div>

        {/* Pagination */}
        {totalPages > 1 && (
          <div className={styles.pagination}>
            <button 
              className={`${styles.paginationButton} ${currentPage === 1 ? styles.disabled : ''}`}
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
            >
              Previous
            </button>
            <div className={styles.pageNumbers}>
              {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                <button
                  key={page}
                  className={`${styles.pageNumber} ${page === currentPage ? styles.activePage : ''}`}
                  onClick={() => handlePageChange(page)}
                >
                  {page}
                </button>
              ))}
            </div>
            <button 
              className={`${styles.paginationButton} ${currentPage === totalPages ? styles.disabled : ''}`}
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
            >
              Next
            </button>
          </div>
        )}
      </div>
    </div>
    <Footer/>
    </>
  );
};

export default DocumentarySection;